const chinese = {
    search_title: '搜索',
    search_everything: '寻找奈良周边的一切',
    search_accommodation: '寻找奈良周边的住宿',
    search_activity: '寻找奈良周边的活动',
    search_product: '寻找奈良周边的商品',
    search_restaurant: '寻找奈良周边的餐厅',
    search_subtitle: `查找奈良周边的活动`,
    search_subsubtitle: `您可以将任何服务/产品添加到愿望清单中。`,
    search_button: `搜索`,
    search_price_range: '价格范围',
    search_all_categories: '所有类别',
    accommodation: '住宿',
    activity: '活动',
    restaurant: '餐厅',
    produce: '生产',
    search_keyword: '类型关键字',
    wishlist_empty: '购物车是空的',
    close: '关',
    check_availability: '继续付款',
    load_more: '装载更多',
    loading: ' 加载中 ...',
    view_details: '看法',
    basic_info: '基本信息',
    map: '地图',
    details: '细节',
    home: '家',
    list: '列表',
    name: '名称',
    address: '地址',
    phone: '电话',
    website: '网站',
    email: '电子邮件',
    fax: '传真',
    from: '从',
    price: '价钱',
    rate: '速度',
    under_maintenance: '',
    add_to_wishlist: '现在预订',
    remove_from_wishlist: '删除书籍',
    wishlist: '大车',
    not_available: '无法使用',
    night: '夜晚',
    guest: '客人',
    item: '物品',
    date: '日期',
    read_more: '阅读更多',
    check_price_availability: '检查价格和可用性',
    available_products: '可用产品',
    start_time: '开始时间',
    different_time: '或选择其他时间',
    dairy: '乳制品',
    sweet: '甜的',
    wine: '葡萄酒',
    quantity: '数量',
    request_to_book: '要求预订',
    sort_by: '排序方式',
    name_az: '名称 - 升序',
    name_za: '名称 - 降序',
    price_az: '价格 - 上升',
    price_za: '价格 - 降序',
    extras: '附加功能',
    no_public_website: '没有公共网站',
    no_public_email: 'No Public Email,',
    firstName: 'First Name',
    lastName: 'Last Name',
    userEmail: 'Email',
    conf_email: 'Re-Type Email',
    mobile: 'Mobile/Cell Phone',
    city: 'Suburb/City',
    state: 'State/Country',
    zipcode: 'Post Code/Zip',
    country: 'Country',
    marketing: 'Marketing',
    business: 'Business',
    specialRequest: 'Special Request Note',
    is_required: ' is required',
    is_not_the_same: ' is not the same',
    is_not_a_valid_email: ' is not valid',
    must_be_a_number: ' must be a number',
    select_country: 'Select Country',
    submit: 'Submit',
    customer_detail: 'Customer Detail',
    booking_information: 'Booking Information',
    product: 'Product',
    options_costs: 'Options/Costs',
    totals: 'Totals',
    adult: 'Adult(s)',
    check_in: 'Check In',
    check_out: 'Check Out',
    back_to_nara: 'Back To Nara',
    booking_req_detail_wait: 'Booking Request Details - awaiting confirmation',
    booking_req_instructions: "You'll receive an email within 24 hours to confirm if your booking request has been accepted by the operator. Payment is not due until your booking request has been accepted.",
    request_date: 'Request Date (UTC)',
    booking_reference: 'Booking Reference',
    booked_by: 'Booked by',
    supplier_information: 'Supplier Information',
    total_gst: 'Total (inc. GST)',
    amount_paid: 'Amount Paid (inc. GST)',
    amount_owing: 'Amount Owing (inc. GST)',
};
export default chinese;
